/* eslint-disable react-hooks/rules-of-hooks */
import { WorkspaceAPI } from "@radarly/api/workspace";
import { useWorkspace } from "../context";
import { Pagination, WorkspaceRepository } from "./WorkspaceRepository";

interface Dependencies {
  workspaceAPI: WorkspaceAPI;
}

export class APIWorkspaceRepository implements WorkspaceRepository {
  private workspaceAPI: WorkspaceAPI;
  constructor(dependencies: Dependencies) {
    this.workspaceAPI = dependencies.workspaceAPI;
  }
  public getCurrentWorkspace() {
    return useWorkspace();
  }
  public getProjectWorkspaces(projectId: number) {
    return this.workspaceAPI.getProjectWorkspaces(projectId);
  }
  public async searchWorkspaces(search: string, pagination: Pagination) {
    return this.workspaceAPI
      .searchWorkspaces(search, pagination)
      .then(({ dashboards }) => dashboards);
  }
}
